 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];

 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}

 		return result;
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded CSS chunks
 	var installedCssChunks = {
 		"app": 0
 	}

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		"app": 0
 	};

 	var deferredModules = [];

 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "js/" + ({}[chunkId]||chunkId) + "." + {"chunk-01347eea":"e96d380d","chunk-0232e452":"a34ef048","chunk-1ca8281b":"45441fd4","chunk-1259bed9":"24222079","chunk-2cb63e3a":"461dc2fd","chunk-1a753740":"dbcf1425","chunk-2d2172bd":"503d9680","chunk-10b587b9":"89922248","chunk-2fefc2ba":"384f4174","chunk-375c8d73":"6cb109d1","chunk-1d11387c":"b6ad113d","chunk-00978fa7":"850a510d","chunk-4319630e":"23f05726","chunk-348c457e":"b3bae189","chunk-d4a1374e":"49030573","chunk-17829288":"15d61754","chunk-1f5af716":"4dc54d0c","chunk-46cbb527":"e1d0cb2c","chunk-56e47990":"a9346649","chunk-3d494bb4":"8aa81893","chunk-20fd3c50":"8971fbbb","chunk-2751310e":"d1111611","chunk-2d22693c":"a4fb039f","chunk-5c4c15db":"2fa529fb","chunk-3bb998a8":"fcf0916d","chunk-67429d6f":"f8cdc809","chunk-797abe5a":"0a7efe3b","chunk-2d22d3f4":"7a5cfb55","chunk-6ac244a9":"2d40928d","chunk-1f359188":"798d37d7","chunk-29bebfab":"def67533","chunk-2d0a3159":"b4a0a482","chunk-2d0dd7af":"ea3dcbd1","chunk-2d0ddba1":"a95b9059","chunk-2d20864f":"7e5704ce","chunk-2d22b970":"888adf82","chunk-2d21a841":"1192dd1b","chunk-2d237ffc":"8048172a","chunk-2d35d371":"987da2d0","chunk-cdd5f0c2":"ad231524","chunk-4442e952":"5c17ee1f","chunk-50d21eb3":"103b9b0e","chunk-52d70ce8":"edf458c0","chunk-57cc81a2":"efa342f9","chunk-df2ead5c":"7fbaa38f","chunk-08a87dc8":"4a7d5c80","chunk-2d0aa281":"0d842714","chunk-25352464":"708262f6","chunk-2d0ae5d6":"2de6e58e","chunk-2d0da355":"51468348","chunk-2d216ba8":"65a9d156","chunk-b57fc804":"93646cd2","chunk-5cc1684b":"96cced24","chunk-68d1576d":"c3073b5e","chunk-6f197e96":"91c0ee40","chunk-a9632ad4":"da0dbec2","chunk-b815aa6c":"ed1fa1bc","chunk-c685d320":"f7728177","chunk-50a95140":"f69d1081","chunk-ddbd689a":"8175f351","chunk-8e989028":"10566aaa","chunk-ea0efcd2":"5187e3c7","chunk-ecae29fc":"a32cd3a0","chunk-f8432fd6":"aa91a195","chunk-10d582ee":"b19f13cc","chunk-1d94d3f1":"65caf476","chunk-2d0cc2ee":"4f9f2e29","chunk-3e2e8798":"2caad180","chunk-401d5cd2":"70797e35","chunk-17a63ea5":"38b055de","chunk-2d209b31":"54072f58","chunk-0987dada":"6e30d4be","chunk-70413996":"72eb5983","chunk-b6513c58":"ad56fa04","chunk-fffe9a3a":"28f891af","chunk-2d2223ef":"ba1a7aba","chunk-2d607d30":"1a1de024","chunk-2f83f030":"d1addcdb","chunk-4aad5e3d":"bc853aa3","chunk-55693694":"f0aa9a3a","chunk-62fe80ef":"56077f26","chunk-71fa889d":"3722f2c2","chunk-743c2ddb":"a76340f5","chunk-745a3122":"a496ad2d","chunk-7467d5b8":"81acc37a","chunk-7482e5bc":"a45e4312","chunk-74af77ea":"72d835d8","chunk-74b7681c":"af3b4519","chunk-74bb0962":"1d1c34d4","chunk-76f042f8":"cf4c94f3","chunk-774c8cf7":"d2e748d9","chunk-7d47e309":"4b9d8ba1","chunk-037567df":"4ad353fa","chunk-3bafb6c4":"889ea33d","chunk-ad1740b0":"0754e03e","chunk-ba57138a":"6f58052d","chunk-c0f817d4":"d5dc08ad","chunk-f210cb80":"09f0c8a4","chunk-2cf0b788":"6416903d","chunk-e0125934":"8139dc22","chunk-206c6aaa":"411f42a7","chunk-7457c560":"de003d3e"}[chunkId] + ".js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// mini-css-extract-plugin CSS loading
 		var cssChunks = {"chunk-01347eea":1,"chunk-0232e452":1,"chunk-1ca8281b":1,"chunk-1259bed9":1,"chunk-2cb63e3a":1,"chunk-1a753740":1,"chunk-10b587b9":1,"chunk-2fefc2ba":1,"chunk-375c8d73":1,"chunk-1d11387c":1,"chunk-4319630e":1,"chunk-348c457e":1,"chunk-d4a1374e":1,"chunk-17829288":1,"chunk-1f5af716":1,"chunk-46cbb527":1,"chunk-56e47990":1,"chunk-3d494bb4":1,"chunk-20fd3c50":1,"chunk-2751310e":1,"chunk-5c4c15db":1,"chunk-3bb998a8":1,"chunk-67429d6f":1,"chunk-797abe5a":1,"chunk-6ac244a9":1,"chunk-1f359188":1,"chunk-29bebfab":1,"chunk-2d35d371":1,"chunk-cdd5f0c2":1,"chunk-4442e952":1,"chunk-50d21eb3":1,"chunk-52d70ce8":1,"chunk-57cc81a2":1,"chunk-08a87dc8":1,"chunk-25352464":1,"chunk-5cc1684b":1,"chunk-68d1576d":1,"chunk-6f197e96":1,"chunk-a9632ad4":1,"chunk-b815aa6c":1,"chunk-c685d320":1,"chunk-50a95140":1,"chunk-ddbd689a":1,"chunk-8e989028":1,"chunk-ea0efcd2":1,"chunk-ecae29fc":1,"chunk-f8432fd6":1,"chunk-10d582ee":1,"chunk-1d94d3f1":1,"chunk-401d5cd2":1,"chunk-17a63ea5":1,"chunk-0987dada":1,"chunk-70413996":1,"chunk-b6513c58":1,"chunk-fffe9a3a":1,"chunk-2d607d30":1,"chunk-2f83f030":1,"chunk-4aad5e3d":1,"chunk-55693694":1,"chunk-62fe80ef":1,"chunk-71fa889d":1,"chunk-743c2ddb":1,"chunk-745a3122":1,"chunk-7467d5b8":1,"chunk-7482e5bc":1,"chunk-74af77ea":1,"chunk-74b7681c":1,"chunk-74bb0962":1,"chunk-76f042f8":1,"chunk-774c8cf7":1,"chunk-037567df":1,"chunk-3bafb6c4":1,"chunk-ad1740b0":1,"chunk-ba57138a":1,"chunk-c0f817d4":1,"chunk-f210cb80":1,"chunk-2cf0b788":1,"chunk-e0125934":1,"chunk-206c6aaa":1,"chunk-7457c560":1};
 		if(installedCssChunks[chunkId]) promises.push(installedCssChunks[chunkId]);
 		else if(installedCssChunks[chunkId] !== 0 && cssChunks[chunkId]) {
 			promises.push(installedCssChunks[chunkId] = new Promise(function(resolve, reject) {
 				var href = "css/" + ({}[chunkId]||chunkId) + "." + {"chunk-01347eea":"14130ea8","chunk-0232e452":"e4bde69a","chunk-1ca8281b":"0bb5e88d","chunk-1259bed9":"bc3c400f","chunk-2cb63e3a":"7de0dee6","chunk-1a753740":"93d03891","chunk-2d2172bd":"31d6cfe0","chunk-10b587b9":"5f492552","chunk-2fefc2ba":"3b1cc4df","chunk-375c8d73":"4f501797","chunk-1d11387c":"a69796ff","chunk-00978fa7":"31d6cfe0","chunk-4319630e":"15b9cb31","chunk-348c457e":"d38756b5","chunk-d4a1374e":"a136cfdd","chunk-17829288":"a1a24b77","chunk-1f5af716":"52b16da9","chunk-46cbb527":"88219f6f","chunk-56e47990":"fce8b943","chunk-3d494bb4":"6c22b62d","chunk-20fd3c50":"3db94c2d","chunk-2751310e":"7e1ecbad","chunk-2d22693c":"31d6cfe0","chunk-5c4c15db":"832f84b9","chunk-3bb998a8":"6131c62d","chunk-67429d6f":"e5e91848","chunk-797abe5a":"7e3bf0b6","chunk-2d22d3f4":"31d6cfe0","chunk-6ac244a9":"325daf6f","chunk-1f359188":"d501907c","chunk-29bebfab":"ef0da253","chunk-2d0a3159":"31d6cfe0","chunk-2d0dd7af":"31d6cfe0","chunk-2d0ddba1":"31d6cfe0","chunk-2d20864f":"31d6cfe0","chunk-2d22b970":"31d6cfe0","chunk-2d21a841":"31d6cfe0","chunk-2d237ffc":"31d6cfe0","chunk-2d35d371":"e1d0fec9","chunk-cdd5f0c2":"f1baeb9b","chunk-4442e952":"04ea624b","chunk-50d21eb3":"9f69edb5","chunk-52d70ce8":"f4907313","chunk-57cc81a2":"37df1425","chunk-df2ead5c":"31d6cfe0","chunk-08a87dc8":"2d2d56a7","chunk-2d0aa281":"31d6cfe0","chunk-25352464":"92511c68","chunk-2d0ae5d6":"31d6cfe0","chunk-2d0da355":"31d6cfe0","chunk-2d216ba8":"31d6cfe0","chunk-b57fc804":"31d6cfe0","chunk-5cc1684b":"855f9447","chunk-68d1576d":"150be8e4","chunk-6f197e96":"99358cdb","chunk-a9632ad4":"ddb6d2a6","chunk-b815aa6c":"666d41cc","chunk-c685d320":"36c4aa08","chunk-50a95140":"f4394b3c","chunk-ddbd689a":"f0417e24","chunk-8e989028":"f715dc6f","chunk-ea0efcd2":"468b9773","chunk-ecae29fc":"2457469d","chunk-f8432fd6":"2457469d","chunk-10d582ee":"91868441","chunk-1d94d3f1":"a140772d","chunk-2d0cc2ee":"31d6cfe0","chunk-3e2e8798":"31d6cfe0","chunk-401d5cd2":"6cb98cce","chunk-17a63ea5":"0da95f5b","chunk-2d209b31":"31d6cfe0","chunk-0987dada":"db5d03c5","chunk-70413996":"aa948169","chunk-b6513c58":"b196006c","chunk-fffe9a3a":"74b95111","chunk-2d2223ef":"31d6cfe0","chunk-2d607d30":"d09cf3eb","chunk-2f83f030":"f2e3d023","chunk-4aad5e3d":"2405960a","chunk-55693694":"2e1a912a","chunk-62fe80ef":"c0261f0b","chunk-71fa889d":"07cc3c21","chunk-743c2ddb":"0dd2478f","chunk-745a3122":"d7dc1639","chunk-7467d5b8":"97906909","chunk-7482e5bc":"3fc962f4","chunk-74af77ea":"23b17eb2","chunk-74b7681c":"6ff76692","chunk-74bb0962":"06c127ee","chunk-76f042f8":"a3d504dc","chunk-774c8cf7":"93e9293c","chunk-7d47e309":"31d6cfe0","chunk-037567df":"d4b79940","chunk-3bafb6c4":"47b392f8","chunk-ad1740b0":"18f5736b","chunk-ba57138a":"c62c4385","chunk-c0f817d4":"7bfbbbb7","chunk-f210cb80":"5da84a9f","chunk-2cf0b788":"a97febbf","chunk-e0125934":"367bb202","chunk-206c6aaa":"78b1df5a","chunk-7457c560":"d4ad834b"}[chunkId] + ".css";
 				var fullhref = __webpack_require__.p + href;
 				var existingLinkTags = document.getElementsByTagName("link");
 				for(var i = 0; i < existingLinkTags.length; i++) {
 					var tag = existingLinkTags[i];
 					var dataHref = tag.getAttribute("data-href") || tag.getAttribute("href");
 					if(tag.rel === "stylesheet" && (dataHref === href || dataHref === fullhref)) return resolve();
 				}
 				var existingStyleTags = document.getElementsByTagName("style");
 				for(var i = 0; i < existingStyleTags.length; i++) {
 					var tag = existingStyleTags[i];
 					var dataHref = tag.getAttribute("data-href");
 					if(dataHref === href || dataHref === fullhref) return resolve();
 				}
 				var linkTag = document.createElement("link");
 				linkTag.rel = "stylesheet";
 				linkTag.type = "text/css";
 				linkTag.onload = resolve;
 				linkTag.onerror = function(event) {
 					var request = event && event.target && event.target.src || fullhref;
 					var err = new Error("Loading CSS chunk " + chunkId + " failed.\n(" + request + ")");
 					err.code = "CSS_CHUNK_LOAD_FAILED";
 					err.request = request;
 					delete installedCssChunks[chunkId]
 					linkTag.parentNode.removeChild(linkTag)
 					reject(err);
 				};
 				linkTag.href = fullhref;

 				var head = document.getElementsByTagName("head")[0];
 				head.appendChild(linkTag);
 			}).then(function() {
 				installedCssChunks[chunkId] = 0;
 			}));
 		}

 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "https://presenter.ahaslides.com/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// add entry module to deferred list
 	deferredModules.push([1,"chunk-vendors"]);
 	// run deferred modules when ready
 	return checkDeferredModules();
